import callApi from "helpers/callApi";
import { getFundRequestByIdEndpoint, FundRequestApiError } from "./requestFundsCreateApi";

export function getFundRequestSendEndpoint(fundRequestId) {
  return `${getFundRequestByIdEndpoint(fundRequestId)}/send`;
}

async function readFundRequestSendResponseBody(response) {
  try {
    const text = await response.text();
    if (text == null || String(text).trim() === "") {
      return null;
    }
    return JSON.parse(text);
  } catch {
    return null;
  }
}

async function throwFundRequestSendApiError(response) {
  const body = await readFundRequestSendResponseBody(response);
  throw new FundRequestApiError(response.errorMessage || "Error", {
    status: response.status,
    body,
  });
}

export async function sendFundRequest(fundRequestId) {
  const response = await callApi(getFundRequestSendEndpoint(fundRequestId), "POST", {});
  if (!response.ok) {
    await throwFundRequestSendApiError(response);
  }
  return response.json();
}
